// {
//     "type": "MultiChoice",
//     "question": [
//         "Which of the following integer literals uses the *underscore* correctly to improve the readability of **%0%**?"
//     ],
//     "variables": [
//         {
//             "type": "gen",
//             "func": "genPower",
//             "params": {
//                 "base": 10,
//                 "minExp": 2,
//                 "maxExp": 6
//             }
//         }
//     ],
//     "data": {
//         "choices": {
//             "correct": [
//                 {
//                     "type": "gen",
//                     "func": "genIntUnderscores",
//                     "params": {
//                         "value": "%0%",
//                         "correct": true
//                     }
//                 }
//             ],
//             "incorrect": [
//                 {
//                     "type": "gen",
//                     "func": "genIntUnderscores",
//                     "params": {
//                         "value": "%0%",
//                         "correct": false
//                     },
//                     "regen": true
//                 },
//                 {
//                     "type": "gen",
//                     "func": "genIntUnderscores",
//                     "params": {
//                         "value": "%0%",
//                         "correct": false
//                     },
//                     "regen": true
//                 },
//                 {
//                     "type": "gen",
//                     "func": "genIntUnderscores",
//                     "params": {
//                         "value": "%0%",
//                         "correct": false
//                     },
//                     "regen": true
//                 }
//             ]
//         }
//     }
// },
// {
//     "type": "MultiChoice",
//     "question": [
//         "What is the result of **%0% + %1%**?"
//     ],
//     "variables": [
//         {
//             "type": "gen",
//             "func": "genInt",
//             "params": {
//                 "min": 1,
//                 "max": 10
//             }
//         },
//         {
//             "type": "gen",
//             "func": "genInt",
//             "params": {
//                 "min": 1,
//                 "max": 10
//             }
//         }
//     ],
//     "data": {
//         "choices": {
//             "correct": [
//                 {
//                     "type": "gen",
//                     "func": "genExpression",
//                     "params": {
//                         "expression": "%0% + %1%"
//                     }
//                 }
//             ],
//             "incorrect": [
//                 {
//                     "type": "gen",
//                     "func": "genExpression",
//                     "params": {
//                         "expression": "%0% - %1%"
//                     }
//                 },
//                 {
//                     "type": "gen",
//                     "func": "genExpression",
//                     "params": {
//                         "expression": "%0% * %1%"
//                     }
//                 },
//                 {
//                     "type": "gen",
//                     "func": "genExpression",
//                     "variables": [
//                         {
//                             "name": "randomOffset",
//                             "type": "gen",
//                             "func": "genInt",
//                             "params": {
//                                 "min": -3,
//                                 "max": 3,
//                                 "exclusions": [
//                                     0
//                                 ]
//                             }
//                         }
//                     ],
//                     "params": {
//                         "expression": "%0% + %1% + {{randomOffset}}"
//                     },
//                     "regen": true
//                 }
//             ]
//         }
//     }
// },
// {
//     "type": "InputBox",
//     "question": [
//         "Enter an expression that adds **%0%** and **%1%**."
//     ],
//     "variables": [
//         {
//             "type": "gen",
//             "func": "genInt",
//             "params": {
//                 "min": 1,
//                 "max": 10
//             }
//         },
//         {
//             "type": "gen",
//             "func": "genInt",
//             "params": {
//                 "min": 1,
//                 "max": 10
//             }
//         }
//     ],
//     "data": {
//         "segments": [
//             {
//                 "type": "placeholder",
//                 "data": "x = "
//             },
//             {
//                 "type": "input",
//                 "val": [
//                     {
//                         "func": "valExpressionEquals",
//                         "params": {
//                             "expected": "%0% + %1%"
//                         }
//                     }
//                 ]
//             }
//         ]
//     }
// },
// {
//     "type": "TextBox",
//     "question": [
//         "Write code that using *substring* prints the **\"%0%\"** from the string **\"%1%\"**, and prints it %2% times."
//     ],
//     "variables": [
//         {
//             "type": "options",
//             "options": [
//                 "World",
//                 "love",
//                 "amazing"
//             ],
//             "linkId": 1
//         },
//         {
//             "type": "options",
//             "options": [
//                 "Hello World!",
//                 "I love coding",
//                 "This is amazing"
//             ],
//             "linkId": 1
//         },
//         {
//             "type": "gen",
//             "func": "genInt",
//             "params": {
//                 "min": 5,
//                 "max": 100
//             }
//         }
//     ],
//     "data": {
//         "val": [
//             {
//                 "func": "stringSlicing",
//                 "params": {
//                     "substring": "%0%",
//                     "string": "%1%"
//                 }
//             },
//             {
//                 "func": "stringSequence",
//                 "params": {
//                     "value": "%0%",
//                     "count": "%2%"
//                 }
//             }
//         ]
//     }
// },
// {
//     "type": "MultiChoiceSplit",
//     "question": [
//         "How many times will this code print **Hello**?"
//     ],
//     "variables": [
//         {
//             "type": "gen",
//             "func": "genInt",
//             "params": {
//                 "min": 1,
//                 "max": 100
//             }
//         }
//     ],
//     "data": {
//         "code": "for i in range(1, %0%):\n    print(\"Hello\")",
//         "choices": {
//             "correct": [
//                 {
//                     "type": "gen",
//                     "func": "genExpression",
//                     "params": {
//                         "expression": "%0% - 1"
//                     }
//                 }
//             ],
//             "incorrect": [
//                 {
//                     "type": "gen",
//                     "func": "genExpression",
//                     "params": {
//                         "expression": "%0%"
//                     }
//                 },
//                 {
//                     "type": "gen",
//                     "func": "genExpression",
//                     "variables": [
//                         {
//                             "name": "randomAdd",
//                             "type": "gen",
//                             "func": "genInt",
//                             "params": {
//                                 "min": 1,
//                                 "max": 3
//                             }
//                         }
//                     ],
//                     "params": {
//                         "expression": "%0% + {{randomAdd}}"
//                     },
//                     "regen": true
//                 },
//                 {
//                     "type": "gen",
//                     "func": "genExpression",
//                     "variables": [
//                         {
//                             "name": "randomAdd",
//                             "type": "gen",
//                             "func": "genInt",
//                             "params": {
//                                 "min": 1,
//                                 "max": 20
//                             }
//                         }
//                     ],
//                     "params": {
//                         "expression": "%0% + {{randomAdd}}"
//                     },
//                     "regen": true
//                 }
//             ]
//         }
//     }
// }

// {
//         "concept": "Basics",
//         "challenges": [
//             {
//                 "type": "MultiChoice",
//                 "question": [
//                     "Which of the following integer literals uses the *underscore* correctly to improve the readability of **%0%**?"
//                 ],
//                 "variables": [
//                     {
//                         "type": "gen",
//                         "func": "genIntCommas",
//                         "params": {
//                             "value": {
//                                 "type": "gen",
//                                 "func": "genPower",
//                                 "params": {
//                                     "base": 10,
//                                     "minExp": 3,
//                                     "maxExp": 7
//                                 }
//                             }
//                         }
//                     }
//                 ],
//                 "data": {
//                     "options": {
//                         "highlight": false
//                     },
//                     "choices": {
//                         "correct": [
//                             {
//                                 "type": "gen",
//                                 "func": "genIntUnderscores",
//                                 "params": {
//                                     "value": "%0%",
//                                     "correct": true
//                                 }
//                             }
//                         ],
//                         "incorrect": [
//                             {
//                                 "type": "gen",
//                                 "func": "genIntUnderscores",
//                                 "params": {
//                                     "value": "%0%",
//                                     "correct": false
//                                 },
//                                 "regen": true
//                             },
//                             {
//                                 "type": "gen",
//                                 "func": "genIntUnderscores",
//                                 "params": {
//                                     "value": "%0%",
//                                     "correct": false
//                                 },
//                                 "regen": true
//                             },
//                             {
//                                 "type": "gen",
//                                 "func": "genIntUnderscores",
//                                 "params": {
//                                     "value": "%0%",
//                                     "correct": false
//                                 },
//                                 "regen": true
//                             }
//                         ]
//                     }
//                 }
//             },
//             {
//                 "type": "MultiChoice",
//                 "question": [
//                     "What is the result of **%0% + %1%**?"
//                 ],
//                 "variables": [
//                     {
//                         "type": "gen",
//                         "func": "genInt",
//                         "params": {
//                             "min": 1,
//                             "max": 10
//                         }
//                     },
//                     {
//                         "type": "gen",
//                         "func": "genInt",
//                         "params": {
//                             "min": 1,
//                             "max": 10
//                         }
//                     }
//                 ],
//                 "data": {
//                     "choices": {
//                         "correct": [
//                             {
//                                 "type": "gen",
//                                 "func": "genExpression",
//                                 "params": {
//                                     "expression": "%0% + %1%"
//                                 }
//                             }
//                         ],
//                         "incorrect": [
//                             {
//                                 "type": "gen",
//                                 "func": "genExpression",
//                                 "params": {
//                                     "expression": "%0% - %1%"
//                                 }
//                             },
//                             {
//                                 "type": "gen",
//                                 "func": "genExpression",
//                                 "params": {
//                                     "expression": "%0% * %1%"
//                                 }
//                             },
//                             {
//                                 "type": "gen",
//                                 "func": "genExpression",
//                                 "variables": [
//                                     {
//                                         "name": "randomOffset",
//                                         "type": "gen",
//                                         "func": "genInt",
//                                         "params": {
//                                             "min": -3,
//                                             "max": 3,
//                                             "exclusions": [
//                                                 0
//                                             ]
//                                         }
//                                     }
//                                 ],
//                                 "params": {
//                                     "expression": "%0% + %1% + {{randomOffset}}"
//                                 },
//                                 "regen": true
//                             }
//                         ]
//                     }
//                 }
//             },
//             {
//                 "type": "InputBox",
//                 "question": [
//                     "Enter an expression that adds **%0%** and **%1%**."
//                 ],
//                 "variables": [
//                     {
//                         "type": "gen",
//                         "func": "genInt",
//                         "params": {
//                             "min": 1,
//                             "max": 10
//                         }
//                     },
//                     {
//                         "type": "gen",
//                         "func": "genInt",
//                         "params": {
//                             "min": 1,
//                             "max": 10
//                         }
//                     }
//                 ],
//                 "data": {
//                     "segments": [
//                         {
//                             "type": "placeholder",
//                             "data": "x = "
//                         },
//                         {
//                             "type": "input",
//                             "val": [
//                                 {
//                                     "type": "val",
//                                     "func": "valExpressionEquals",
//                                     "params": {
//                                         "expected": "%0% + %1%"
//                                     }
//                                 }
//                             ]
//                         }
//                     ]
//                 }
//             },
//             {
//                 "type": "TextBox",
//                 "question": [
//                     "Write code that using *substring* prints the **\"%0%\"** from the string **\"%1%\"**, and prints it **%2%** times."
//                 ],
//                 "variables": [
//                     {
//                         "type": "options",
//                         "options": [
//                             "World",
//                             "love",
//                             "amazing"
//                         ],
//                         "linkId": 1
//                     },
//                     {
//                         "type": "options",
//                         "options": [
//                             "Hello World!",
//                             "I love coding",
//                             "This is amazing"
//                         ],
//                         "linkId": 1
//                     },
//                     {
//                         "type": "gen",
//                         "func": "genInt",
//                         "params": {
//                             "min": 5,
//                             "max": 100
//                         }
//                     }
//                 ],
//                 "data": {
//                     "default_code": "original = \"%1%\"\n",
//                     "val": [
//                         {
//                             "type": "val",
//                             "func": "valStringSlicing",
//                             "params": {
//                                 "substring": "%0%",
//                                 "string": "%1%"
//                             }
//                         },
//                         {
//                             "type": "val",
//                             "func": "valStringSequence",
//                             "params": {
//                                 "value": "%0%",
//                                 "count": "%2%"
//                             }
//                         }
//                     ]
//                 }
//             },
//             {
//                 "type": "MultiChoiceSplit",
//                 "question": [
//                     "How many times will this code print **Hello**?"
//                 ],
//                 "variables": [
//                     {
//                         "type": "gen",
//                         "func": "genInt",
//                         "params": {
//                             "min": 1,
//                             "max": 100
//                         }
//                     }
//                 ],
//                 "data": {
//                     "code": "for i in range(1, %0%):\n    print(\"Hello\")",
//                     "choices": {
//                         "correct": [
//                             {
//                                 "type": "gen",
//                                 "func": "genExpression",
//                                 "params": {
//                                     "expression": "%0% - 1"
//                                 }
//                             }
//                         ],
//                         "incorrect": [
//                             {
//                                 "type": "gen",
//                                 "func": "genExpression",
//                                 "params": {
//                                     "expression": "%0%"
//                                 }
//                             },
//                             {
//                                 "type": "gen",
//                                 "func": "genExpression",
//                                 "variables": [
//                                     {
//                                         "name": "randomAdd",
//                                         "type": "gen",
//                                         "func": "genInt",
//                                         "params": {
//                                             "min": 1,
//                                             "max": 3
//                                         }
//                                     }
//                                 ],
//                                 "params": {
//                                     "expression": "%0% + {{randomAdd}}"
//                                 },
//                                 "regen": true
//                             },
//                             {
//                                 "type": "gen",
//                                 "func": "genExpression",
//                                 "variables": [
//                                     {
//                                         "name": "randomAdd",
//                                         "type": "gen",
//                                         "func": "genInt",
//                                         "params": {
//                                             "min": 1,
//                                             "max": 20
//                                         }
//                                     }
//                                 ],
//                                 "params": {
//                                     "expression": "%0% + {{randomAdd}}"
//                                 },
//                                 "regen": true
//                             }
//                         ]
//                     }
//                 }
//             }
//         ]
//     },

import * as generators from 'utils/generators.js';
import * as validators from 'utils/validators.js';

export function replaceVariablesInText(text, variables = [], localVars = []) {
    if (typeof text !== 'string' || (!variables.length && !localVars.length)) {
        return text;
    }


    let result = text;
    const original = text;

    // indexed vars
    variables.forEach((val, i) => {

        const safe = val == null ? '' : String(val.value);
        result = result.replace(new RegExp(`%${i}%`, 'g'), safe);
    });

    // named vars
    localVars.forEach((val, i) => {
        let name = val.name;
        result = result.replace(new RegExp(`{{${name}}}`, 'g'), val.value);
    });

    if (original !== result) {
        // console.log('[replaceVariablesInText] replaced:', { from: original, to: result, variables, localVars });
    }

    // console.log('[replaceVars] replaced:', { from: original, to: result, variables, localVars });

    return result;
}

function mergeVariableSources(globalVars, localVars) {
    const base = Array.isArray(globalVars) ? globalVars : [];
    const locals = Array.isArray(localVars) ? localVars : [];
    return locals.length ? [...base, ...locals] : base;
}

export function parseValue(def, variables = [], localVars = [], linkedIndexs = {}, valCustomParams = {}) {
    if (def == null) {
        console.warn('parseValue: received null or undefined definition');
        return { value: '', name: undefined, regen: false };
    }

    if (typeof def === 'string') {
        return { value: replaceVariablesInText(def, variables, localVars), name: undefined, regen: false };
    }
    if (typeof def === 'number') {
        return { value: def, name: undefined, regen: false };
    }

    if (!def || typeof def !== 'object' || !def.type) {
        throw new Error('Invalid value definition:', def);
    }

    const regen = !!def.regen;
    const name = def.name;

    switch (def.type) {
        case 'value': {
            const raw = def.value;
            if (typeof raw !== 'string' && typeof raw !== 'number') {
                throw new Error('type:value → rawValue must be string|number');
            }

            // localVars = [];
            if (Array.isArray(def.variables)) {
                const nested = parseValueList(
                    def.variables,
                    true,
                    mergeVariableSources(variables, localVars),
                    null,
                    {},
                    localVars
                );
                localVars.push(...nested);
            }

            // console.log('[parseValue] raw value:', { raw, variables, localVars });
            const replaced = replaceVariablesInText(String(raw), variables, localVars);
            return { value: replaced, name, regen };
        }

        case 'options': {
            const opts = def.options;
            if (!Array.isArray(opts) || opts.length === 0) {
                throw new Error('type:options → invalid or empty options[]');
            }

            // normalize exclude to array
            let exclude = def.exclude != null ? ([]).concat(def.exclude) : [];
            exclude = exclude.map(ex => {
                return parseValue(ex, variables, localVars, linkedIndexs).value;
            });

            let idx;
            let attempts = 0;
            const maxAttempts = 50; // avoid infinite loops

            do {
                if (def.linkId != null) {
                    if (linkedIndexs[def.linkId] != null) {
                        idx = linkedIndexs[def.linkId];
                    } else {
                        idx = Math.floor(Math.random() * opts.length);
                        linkedIndexs[def.linkId] = idx;
                    }
                } else {
                    idx = Math.floor(Math.random() * opts.length);
                }
                attempts++;
            } while (exclude.includes(opts[idx]) && attempts < maxAttempts);

            if (attempts >= maxAttempts) {
                throw new Error('type:options → could not find non-excluded option');
            }

            // replace variables in option
            const opt = parseValue(opts[idx], variables, localVars).value;
            return { value: opt, name, regen };
        }

        case 'gen': {

            // console.log('[parseValue] Generating value with definition:', def, 'and variables:', variables, 'localVars:', localVars, 'linkedIndexs:', linkedIndexs);

            const fn = generators[def.func];
            if (typeof fn !== 'function') {
                throw new Error(`Unknown generator function: ${def.func}`);
            }

            if (Array.isArray(def.variables)) {
                const nested = parseValueList(
                    def.variables,
                    true,
                    mergeVariableSources(variables, localVars),
                    null,
                    {},
                    localVars
                );
                localVars.push(...nested);
            }

            // prepare params (with variable replacement)
            const params = parseParams(def.params, variables, localVars, linkedIndexs);
            // console.log('Running gen function:', def.func, 'with params:', params);
            const generated = fn(params);
            if (generated == null) {
                console.error('Generator function returned null or undefined:', def.func, 'with params:', params);
                // throw new Error(`Generator ${def.func} returned invalid`);
                return { value: '', name, regen }; // Return empty string if generation fails
            }
            return { value: generated, name, regen };
        }

        case 'val': {
            const fn = validators[def.func];
            if (typeof fn !== 'function') {
                throw new Error(`Unknown validator function: ${def.func}`);
            }

            // Handle both array-based variables (indexed) and object-based variables (named)
            if (Array.isArray(def.variables)) {
                const nested = parseValueList(
                    def.variables,
                    true,
                    mergeVariableSources(variables, localVars),
                    null,
                    {},
                    localVars
                );
                localVars.push(...nested);
            } else if (def.variables && typeof def.variables === 'object') {
                // Handle named variables like { randNum: {...}, otherVar: {...} }
                for (const [varName, varDef] of Object.entries(def.variables)) {
                    const parsed = parseValue(varDef, variables, localVars, linkedIndexs);
                    localVars.push({ name: varName, value: parsed.value, regen: parsed.regen });
                }
            }

            const params = parseParams(def.params, variables, localVars, linkedIndexs);
            // console.log('Running gen function:', def.func, 'with params:', params);
            const generated = fn(valCustomParams, params);
            if (generated == null) {
                console.error('Validator function returned null or undefined:', def.func, 'with params:', params);
                // throw new Error(`Generator ${def.func} returned invalid`);
                return { value: '', name, regen }; // Return empty string if validation fails
            }
            return { value: generated, name, regen };
        }

        default:
            throw new Error(`Unsupported type: ${def.type}`);
    }
}

function parseParams(params, variables, localVars, linkedIndexs) {
    params = { ...params } || {};
    for (const [k, v] of Object.entries(params || {})) {
        if (typeof v === 'string') {
            params[k] = replaceVariablesInText(v, variables, localVars);
            //  check if the value is a number alone in a string
            if (!isNaN(params[k]) && params[k]?.trim() !== '') {
                params[k] = parseFloat(params[k]);
            }
            // console.log('Parsed param:', k, '→', params[k]);
        } else if (typeof v === 'object' && !Array.isArray(v) && v !== null) {
            // Only parse if it looks like a value definition (has a 'type' field)
            // Otherwise, pass through as plain object
            if (v.type) {
                params[k] = parseValue(v, variables, localVars, linkedIndexs).value;
            } else {
                // Plain object - recursively process its values for variable replacement
                params[k] = parseParams(v, variables, localVars, linkedIndexs);
            }
        } else if (Array.isArray(v)) {
            // If the value is an array, parse each item
            // console.log('Parsing array:', v, 'with variables:', variables, 'and localVars:', localVars);
            params[k] = v.map(item => {
                // console.log('Parsing array item:', item, 'with variables:', variables, 'and localVars:', localVars);

                // Only parse if it looks like a value definition or is a primitive
                if (typeof item === 'object' && item !== null && !Array.isArray(item)) {
                    if (item.type) {
                        return parseValue(item, variables, localVars, linkedIndexs).value;
                    } else {
                        // Plain object in array - recursively process
                        return parseParams(item, variables, localVars, linkedIndexs);
                    }
                } else {
                    return parseValue(item, variables, localVars, linkedIndexs).value;
                }
            });
        } else {
            params[k] = v;
        }
    }
    return params;
}

export function parseValueList(
    valueList,
    isVariableList = false,
    variables = [],
    invalidDuplicate = null,
    valCustomParams = "",
    initialLocalVars = []
) {
    if (!Array.isArray(valueList)) {
        return [];
    }

    let linkedIndexs = {};

    const output = [];

    // console.log('[parseValueList] valueList:', JSON.stringify(valueList, null, 2), '\nvariables:', variables, '\nisVariableList:', isVariableList, '\ninvalidDuplicate:', invalidDuplicate);

    let storedLocalVars = Array.isArray(initialLocalVars) ? [...initialLocalVars] : [];

    for (const valueDefinition of valueList) {
        const availableVars = isVariableList ? [...variables, ...output] : variables;
        // const availableVars = [...output, ...variables];
        // console.log("adding output", output, "variables", variables);
        // const availableVars = variables;

        // console.log('[parseValueList] Parsing value definition:', valueDefinition, 'with availableVars:', availableVars, 'storedLocalVars:', storedLocalVars, 'linkedIndexs:', linkedIndexs, 'valCustomParams:', valCustomParams);
        let { value, name, regen } = parseValue(valueDefinition, availableVars, storedLocalVars, linkedIndexs, valCustomParams);

        let isDup = !isVariableList && output.some(e => String(e.value).trim() === String(value).trim());
        let isInvalid = !isVariableList && invalidDuplicate != null && String(value).trim() === String(invalidDuplicate).trim();

        if (!isVariableList && (isDup || isInvalid)) {
            // If this value is regen, try to regen it up to 50 times
            if (regen) {
                let attempts = 0;
                const maxAttempts = 50;
                while (attempts < maxAttempts) {
                    let { value: newValue } = parseValue(valueDefinition, availableVars, [], linkedIndexs, valCustomParams);
                    let isDupNow = output.some(e => String(e.value).trim() === String(newValue).trim());
                    let isInvalidNow = invalidDuplicate != null && String(newValue).trim() === String(invalidDuplicate).trim();
                    if (!isDupNow && !isInvalidNow) {
                        value = newValue;
                        break;
                    }
                    attempts++;
                }
                if (attempts === maxAttempts) {
                    console.warn("Max attempts reached, using original value:", value);
                }
            } else if (isDup) {
                // If not regen, but duplicate, try to regen a previous regen value
                let regenIndex = output.findIndex(e => e.regen);
                if (regenIndex !== -1) {
                    let attempts = 0;
                    const maxAttempts = 50;
                    while (attempts < maxAttempts) {
                        let { value: newValue } = parseValue(valueList[regenIndex], availableVars, [], linkedIndexs, valCustomParams);
                        let isDupNow = output.some((e, idx) => idx !== regenIndex && String(e.value).trim() === String(newValue).trim());
                        let isInvalidNow = invalidDuplicate != null && String(newValue).trim() === String(invalidDuplicate).trim();
                        if (!isDupNow && !isInvalidNow) {
                            output[regenIndex].value = newValue;
                            break;
                        }
                        attempts++;
                    }
                    if (attempts === maxAttempts) {
                        console.warn("Max attempts reached, using original value for regen index:", output[regenIndex].value);
                    }
                }
            }
        }

        if (name) {
            storedLocalVars.push({ name, value, regen });
        }
        output.push({ value, name, regen });
    }

    return output;
}

export function checkFunc(value, validator = true) {
    let funcList = Array.isArray(value) ? value : [value];
    if (funcList.length === 0) {
        return false;
    }
    for (let i = 0; i < funcList.length; i++) {
        let val = funcList[i].func;
        if (typeof val !== 'string') {
            return false;
        }
        if (validator) {
            let func = validators[val];
            if (typeof func !== 'function') {
                return false;
            }
        } else {
            let func = generators[val];
            if (typeof func !== 'function') {
                return false;
            }
        }
    }
    return true;

}